import React from 'react';
import parse from 'html-react-parser';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { generateSurfaceUrl, generateUrl } from '../../common/utils/environments';
import voca from 'voca';
import { pluginCode } from 'drapcode-constant';

const PluginDescription = ({ code, description, projectDetail }) => {
  let environments,
    seoName = '';
  if (projectDetail) {
    environments = projectDetail.environments;
    seoName = projectDetail.seoName;
  }

  const getOAuthCallbackUrl = (env) => {
    const finalUrl = `${generateSurfaceUrl(env.envType, seoName)}login-oauth2/callback`;
    return (
      <li className="d-flex">
        <h5 style={{ textTransform: 'none' }}>
          &nbsp;
          <span style={{ fontWeight: 600 }}>{voca.titleCase(env.envType)}</span>: {finalUrl}
        </h5>
      </li>
    );
  };
  const getSocialLoginCallbackUrl = (env, socialApp) => {
    const finalUrl = `${generateSurfaceUrl(env.envType, seoName)}auth/${socialApp}/callback`;
    return (
      <li className="d-flex">
        <h5 style={{ textTransform: 'none' }}>
          &nbsp;
          <span style={{ fontWeight: 600 }}>{voca.titleCase(env.envType)}</span>: {finalUrl}
        </h5>
      </li>
    );
  };
  const getGoogleCallbackUrl = (env, service) => {
    const finalUrl = `${generateUrl(
      projectDetail,
      env.envType,
    )}google/google-${service}/auth/callback`;
    return (
      <li className="d-flex">
        <h5 style={{ textTransform: 'none' }}>
          &nbsp;
          <span style={{ fontWeight: 600 }}>{voca.titleCase(env.envType)}</span>: {finalUrl}
        </h5>
      </li>
    );
  };
  const getExchangeEngineCallbackUrl = (env, serviceName) => {
    const finalUrl = `${generateUrl(projectDetail, env.envType)}${serviceName}/auth/callback`;
    return (
      <li className="d-flex">
        <h5 style={{ textTransform: 'none' }}>
          &nbsp;
          <span style={{ fontWeight: 600 }}>{voca.titleCase(env.envType)}</span>: {finalUrl}
        </h5>
      </li>
    );
  };
  const getBoldSignWebhookUrl = (env) => {
    const finalUrl = `${generateUrl(projectDetail, env.envType)}boldsign/webhook`;
    return (
      <li className="d-flex">
        <h5 style={{ textTransform: 'none' }}>
          &nbsp;
          <span style={{ fontWeight: 600 }}>{voca.titleCase(env.envType)}</span>: {finalUrl}
        </h5>
      </li>
    );
  };
  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
      <div className="plugin-description">
        <h5>{parse(description)}</h5>
        {code === pluginCode.STRIPE_CONNECT ? (
          <>
            <h5>
              <i className={`wb ${drapcodeIcon('important')}`}></i>&nbsp;<b>Important!</b> Set your
              ExternalApis according to the following modes.
            </h5>
            <ul>
              <li>
                <h5>
                  Set Preview Mode ExternalApi to:
                  {`https://${projectDetail ? projectDetail.seoName : ''}.preview.${
                    process.env.REACT_APP_EXCHANGE
                  }api/v1/stripe-connect/externalapi`}
                </h5>
              </li>
              <li>
                <h5>
                  Set Production Mode ExternalApi to:
                  {`https://${projectDetail ? projectDetail.seoName : ''}.api.${
                    process.env.REACT_APP_EXCHANGE
                  }api/v1/stripe-connect/externalapi`}
                </h5>
              </li>
            </ul>
          </>
        ) : (
          ''
        )}
        {code === pluginCode.MULTI_TENANT_SAAS && (
          <h5 style={{ textTransform: 'none' }}>
            <i className={`wb ${drapcodeIcon('warning')} text-warning`}></i>&nbsp;If you need to
            change the collections, you'll need to uninstall the plugin and then install it again.
            Editing the collections directly is not possible.
          </h5>
        )}
        {code === pluginCode.AWS_SIGNATURE && (
          <h5 style={{ textTransform: 'none' }}>
            <i className={`wb ${drapcodeIcon('warning')} text-warning`}></i>&nbsp;We will add AWS
            Signature headers in request and request body will be base64 encoded.
          </h5>
        )}
        <h5 style={{ textTransform: 'none' }}>
          <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;You can always come back and modify
          the setting.
        </h5>
        {code === pluginCode.OAUTH_2 && environments && (
          <>
            <h5 style={{ textTransform: 'none' }}>
              <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;
              <b>Callback URLs</b>
            </h5>
            <ul>{environments.map((env) => getOAuthCallbackUrl(env))}</ul>
          </>
        )}
        {code === pluginCode.FACEBOOK_LOGIN && environments && (
          <>
            <h5 style={{ textTransform: 'none' }}>
              <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;
              <b>Callback URLs</b>
            </h5>
            <ul>{environments.map((env) => getSocialLoginCallbackUrl(env, 'facebook'))}</ul>
          </>
        )}
        {code === pluginCode.TWITTER_LOGIN && environments && (
          <>
            <h5 style={{ textTransform: 'none' }}>
              <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;
              <b>Callback URLs</b>
            </h5>
            <ul>{environments.map((env) => getSocialLoginCallbackUrl(env, 'twitter'))}</ul>
          </>
        )}
        {code === pluginCode.DOCUSIGN && environments && (
          <>
            <h5 style={{ textTransform: 'none' }}>
              <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;
              <b>Callback URLs</b>
            </h5>
            <ul>{environments.map((env) => getSocialLoginCallbackUrl(env, 'docusign'))}</ul>
          </>
        )}
        {code === pluginCode.TYPESENSE_SEARCH && (
          <h5 style={{ textTransform: 'none' }}>
            <i className={`wb ${drapcodeIcon('warning')} text-warning`}></i>&nbsp;Typesense must be
            installed and running on your system/server for this plugin to function properly.
          </h5>
        )}
        {code === pluginCode.GOOGLE_CALENDAR && (
          <>
            <h5 style={{ textTransform: 'none' }}>
              <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;
              <b>Redirect URIs</b>
            </h5>
            <ul>{environments.map((env) => getGoogleCallbackUrl(env, 'calendar'))}</ul>
          </>
        )}
        {code === pluginCode.RESEND && (
          <h5 style={{ textTransform: 'none' }}>
            <i className={`wb ${drapcodeIcon('warning')} text-warning`}></i>&nbsp; Use{' '}
            <strong style={{ fontWeight: 'bold' }}>onboarding@resend.dev</strong> as the From Email
            if your domain is not verified on the Resend portal. If your domain is not verified, you
            will only be able to send emails to the email address you registered with on Resend.
          </h5>
        )}
        {code === pluginCode.GOOGLE_MEET && (
          <>
            <h5 style={{ textTransform: 'none' }}>
              <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;
              <b>Redirect URIs</b>
            </h5>
            <ul>{environments.map((env) => getGoogleCallbackUrl(env, 'meet'))}</ul>
          </>
        )}
        {code === pluginCode.ZOOM && (
          <>
            <h5 style={{ textTransform: 'none' }}>
              <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;
              <b>Redirect URIs</b>
            </h5>
            <ul>{environments.map((env) => getExchangeEngineCallbackUrl(env, 'zoom'))}</ul>
          </>
        )}
        {code === pluginCode.BOX && (
          <>
            <h5 style={{ textTransform: 'none' }}>
              <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;
              <b>Redirect URIs</b>
            </h5>
            <ul>{environments.map((env) => getExchangeEngineCallbackUrl(env, 'box'))}</ul>
          </>
        )}
        {code === pluginCode.BOLDSIGN && (
          <>
            <h5 style={{ textTransform: 'none' }}>
              <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;
              <b>Webhook URLs</b>
            </h5>
            <ul>{environments.map((env) => getBoldSignWebhookUrl(env))}</ul>
          </>
        )}
      </div>
    </div>
  );
};

export default PluginDescription;
